// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3QuiR","calendarButtons":"ClockData_calendarButtons__1oK_r"};